'use client'

import PageContainer from '@/components/container/PageContainer'
import { useEffect, useState } from 'react'
import { useRequestApi } from '@/common/_hooks/useRequestApi'
import Breadcrumb from '@/ptl/layout/shared/breadcrumb/Breadcrumb'
import PageTitle from '@/components/shared/PageTitle'
import { FileList } from '@/common/_components/FileList'
import { FileInfo } from '@/common/_types/fetchData'
import mobileContext from '../_hooks/MobileContext'

interface ItdcBbsContentProps {
  endpoint: string
  renderHeader?: () => JSX.Element
  renderContent: (post: any) => JSX.Element
  renderFooter?: (post: any) => JSX.Element
}

const ItdcBbsContent = ({ endpoint, renderContent }: ItdcBbsContentProps) => {
  const isMobile = mobileContext()

  const [post, setPost] = useState<any>()
  const { sendHttpRequest } = useRequestApi()

  // 만약 헤더 부분도 페이지마다 달라야 한다면
  // 안내 페이지쪽으로 올리고 Prop으로 전달해야 함
  // isMobile이 false일 때만 Breadcrumb 보이기
  const renderHeader = () => (
    <>
      {!isMobile && <Breadcrumb />}
      <PageTitle headClass="page-title-1depth" />
    </>
  )

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await sendHttpRequest(
          'GET',
          endpoint,
          null,
          false,
          {},
          false,
        )
        setPost(response)
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    fetchData()
  }, [endpoint])

  // 만약 첨부파일 부분도 페이지마다 달라야 한다면(첨부파일 그룹이 여러개라든지)
  // 안내 페이지쪽으로 올리고 Prop으로 전달해야 함
  const renderFooter = (post: any) => {
    const aFiles = post?.data?.files.filter(
      (file: { fileClsfNm: string }) => file.fileClsfNm === 'A',
    )

    return (
      <div className="page-conditions marB30">
        <div className="page-conditions-inner">
          <div className="table-scrollable">
            <table className="table table-bordered">
              <caption>첨부파일 테이블</caption>
              <colgroup>
                <col style={{ width: '160px' }}></col>
              </colgroup>
              <tbody>
                <tr>
                  <th className="td-head" scope="row">
                    첨부파일
                  </th>
                  <td colSpan={3}>
                    {aFiles && aFiles.length > 0 ? (
                      post?.data.files.map((file: FileInfo, index: string) =>
                        file.fileClsfNm === 'A' ? (
                          <FileList
                            key={'aGroup' + index}
                            fileInfo={file}
                            downloadUrl={'/som/gbms/files'}
                            imageView={false}
                          />
                        ) : null,
                      )
                    ) : (
                      <>-</>
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    )
  }

  return (
    <PageContainer>
      {renderHeader && renderHeader()}
      {post && renderContent(post)}
      {post &&
        post.data?.files?.length > 0 &&
        renderFooter &&
        renderFooter(post)}
    </PageContainer>
  )
}

export default ItdcBbsContent
